import type { Mode } from 'core/domain/Mode'

import { useConfigContext } from 'config/ui/ConfigContext'

import type { AccessorialOption } from '../../domain/ShipmentCharges'
import { useShipmentChargeTypes } from './useShipmentChargeTypes'
import { useShipmentPriceItemTypes } from './useShipmentPriceItemTypes'

export function useShipmentAccessorialsOptions(mode: Mode): {
  accessorialsOptions: Array<AccessorialOption>
} {
  const configs = useConfigContext()
  const enablePriceItemTypes = configs.enablePriceItemTypes.toBoolean()

  const { shipmentChargeTypes } = useShipmentChargeTypes({ mode, enabled: !enablePriceItemTypes })
  const { priceItemTypes } = useShipmentPriceItemTypes({ mode, enabled: enablePriceItemTypes })

  return { accessorialsOptions: enablePriceItemTypes ? priceItemTypes : shipmentChargeTypes }
}
